/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PoiOutName
 */
export interface PoiOutName {
    /**
     * 
     * @type {string}
     * @memberof PoiOutName
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PoiOutName
     */
    poiId: number;
    /**
     * 
     * @type {Date}
     * @memberof PoiOutName
     */
    modificationDate: Date;
}

export function PoiOutNameFromJSON(json: any): PoiOutName {
    return PoiOutNameFromJSONTyped(json, false);
}

export function PoiOutNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiOutName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'poiId': json['poiId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function PoiOutNameToJSON(value?: PoiOutName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'poiId': value.poiId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


